module.exports = __webpack_public_path__ + "img/communication11.df21fb0c.png";